import React from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { StockIcon } from "./Icons";

const ProductSearchList = ({
  suggest,
  suggestionRefs,
  handleSelect,
  activeIndex,
  type = "product",
}) => {
  return (
    <>
      {type === "product" && (
        <ul className="suggestions-list">
          {suggest.map((product, index) => (
            <li
              key={product._id}
              ref={(el) => (suggestionRefs.current[index] = el)}
              onClick={() => handleSelect(product)}
              className={`suggestion-item ${
                index === activeIndex ? "active-suggestion" : ""
              }`}
            >
              <span className="badge rounded-pill bg-label-navy">
                {product.code}
              </span>{" "}
              - {product.title} -
              <span className="badge bg-label-fall rounded-pill">
                ₹{CurrencyConverter.toCurrency(product.saleprice || 0, "INR")}
              </span>
              {product?.totalStockLeft && (
                <>
                  {"-"}
                  <span className="badge bg-label-space">
                    <StockIcon/>{" "}
                    {product?.totalStockLeft}
                  </span>
                </>
              )}
            </li>
          ))}
        </ul>
      )}
      {type === "customer" && (
        <>
          <ul className="suggestions-list">
            {suggest.map((customer, index) => (
              <li
                ref={(el) => (suggestionRefs.current[index] = el)}
                key={customer._id}
                onClick={() => handleSelect(customer)}
                className={`suggestion-item ${
                  activeIndex === index ? "highlighted" : ""
                }`}
              >
                {customer?.name} -{" "}
                <span className="badge badge-primary badge bg-label-blue rounded-pill">
                  {customer?.phone || customer?.number}
                </span>
                {customer?.referenceid && (
                  <>
                    <small>-</small>{" "}
                    <span className="badge badge-info badge bg-label-secondary rounded-pill">
                      {customer?.referenceid}
                    </span>
                  </>
                )}
              </li>
            ))}
          </ul>
        </>
      )}
    </>
  );
};

export default ProductSearchList;
